import $ from 'jquery';
import  './jquery.vmap.js';
import 'jqvmap/dist/maps/jquery.vmap.usa.js';

export default class {
    constructor(el) {
        this.map = el,

        this.settings = {
            colors: {
                "al": "#BDBCBC",
                "ak": "#BDBCBC",
                "as": "#BDBCBC",
                "az": "#BDBCBC",
                "ar": "#7C7C7B",
                "ca": "#DADADA",
                "co": "#7C7C7B",
                "ct": "#9D9D9C",
                "de": "#7C7C7B",
                "dc": "#BDBCBC",
                "fl": "#DADADA",
                "ga": "#9D9D9C",
                "gu": "#BDBCBC",
                "hi": "#9D9D9C",
                "id": "#7C7C7B",
                "il": "#BDBCBC",
                "in": "#9D9D9C",
                "ia": "#7C7C7B",
                "ks": "#DADADA",
                "ky": "#7C7C7B",
                "la": "#BDBCBC",
                "me": "#BDBCBC",
                "md": "#BDBCBC",
                "ma": "#BDBCBC",
                "mi": "#DADADA",
                "mn": "#BDBCBC",
                "ms": "#9D9D9C",
                "mo": "#9D9D9C",
                "mp": "#9D9D9C",
                "mt": "#9D9D9C",
                "ne": "#9D9D9C",
                "nv": "#9D9D9C",
                "nh": "#7C7C7B",
                "nj": "#BDBCBC",
                "nm": "#9D9D9C",
                "ny": "#DADADA",
                "nc": "#7C7C7B",
                "nd": "#7C7C7B",
                "oh": "#BDBCBC",
                "ok": "#BDBCBC",
                "or": "#BDBCBC",
                "pw": "Palau",
                "pa": "#9D9D9C",
                "pr": "#7C7C7B",

                "ri": "#7C7C7B",
                "sc": "#BDBCBC",
                "sd": "#DADADA",
                "tn": "#DADADA",
                "tx": "#DADADA",
                "ut": "#DADADA",
                "vt": "#9D9D9C",
                "vi": "#9D9D9C",
                "va": "#9D9D9C",
                "wa": "#9D9D9C",
                "wv": "#DADADA",
                "wi": "#9D9D9C",
                "wy": "#BDBCBC"
            },
            states: {
                "al": "al",
                "ak": "ak",
                "az": "az",
                "ar": "ar",
                "ca": "ca",
                "co": "co",
                "ct": " ",
                "de": " ",
                "dc": " ",
                "fl": "fl",
                "ga": "ga",
                "hi": " ",
                "id": "id",
                "il": "il",
                "in": "in",
                "ia": "ia",
                "ks": "ks",
                "ky": "ky",
                "la": "la",
                "me": " ",
                "md": " ",
                "ma": " ",
                "mi": "mi",
                "mn": "mn",
                "ms": "ms",
                "mo": "mo",
                "mt": "mt",
                "ne": "ne",
                "nv": "nv",
                "nh": " ",
                "nj": " ",
                "nm": "nm",
                "ny": "ny",
                "nc": "nc",
                "nd": "nd",
                "oh": "oh",
                "ok": "ok",
                "or": "or",
                "pw": "pw",
                "pa": "pa",

                "ri": " ",
                "sc": "sc",
                "sd": "sd",
                "tn": "tn",
                "tx": "tx",
                "ut": "ut",
                "vt": " ",
                "va": "va",
                "wa": "wa",
                "wv": "wv",
                "wi": "wi",
                "wy": "wy"
            },
            statesLabel: {
                "as": "American Samoa",
                "ct": "Connecticut",
                "dc": "District Of Columbia",
                "de": "Delaware",
                "gu": "Guam",
                "hi": "Hawaii",
                "md": "Maryland",
                "ma": "Massachusetts",
                "mp": "Northern Mariana Islands",
                "nh": "New Hampshire",
                "nj": "New Jersey",
                "pr": "Puerto Rico",
                "ri": "Rhode Island",
                "vt": "Vermont",
                "vi": "Virgin Islands",
                "me": "Maine",
            },
            labelText: {
                "mp": "cnmi"
            },
            manualSelectionLabels: ["as", "gu", "mp", "pr", "vi"],
            allStates:{
                "AL": "Alabama",
                "AK": "Alaska",
                "AS": "American Samoa",
                "AZ": "Arizona",
                "AR": "Arkansas",
                "CA": "California",
                "CO": "Colorado",
                "CT": "Connecticut",
                "DE": "Delaware",
                "DC": "District Of Columbia",
                "FM": "Federated States Of Micronesia",
                "FL": "Florida",
                "GA": "Georgia",
                "GU": "Guam",
                "HI": "Hawaii",
                "ID": "Idaho",
                "IL": "Illinois",
                "IN": "Indiana",
                "IA": "Iowa",
                "KS": "Kansas",
                "KY": "Kentucky",
                "LA": "Louisiana",
                "ME": "Maine",
                "MH": "Marshall Islands",
                "MD": "Maryland",
                "MA": "Massachusetts",
                "MI": "Michigan",
                "MN": "Minnesota",
                "MS": "Mississippi",
                "MO": "Missouri",
                "MT": "Montana",
                "NE": "Nebraska",
                "NV": "Nevada",
                "NH": "New Hampshire",
                "NJ": "New Jersey",
                "NM": "New Mexico",
                "NY": "New York",
                "NC": "North Carolina",
                "ND": "North Dakota",
                "MP": "Northern Mariana Islands",
                "OH": "Ohio",
                "OK": "Oklahoma",
                "OR": "Oregon",
                "PW": "Palau",
                "PA": "Pennsylvania",
                "PR": "Puerto Rico",
                "RI": "Rhode Island",
                "SC": "South Carolina",
                "SD": "South Dakota",
                "TN": "Tennessee",
                "TX": "Texas",
                "UT": "Utah",
                "VT": "Vermont",
                "VI": "Virgin Islands",
                "VA": "Virginia",
                "WA": "Washington",
                "WV": "West Virginia",
                "WI": "Wisconsin",
                "WY": "Wyoming"
            }
        };
        this.clickMap = $.Event('state-change-trigger');
        this.customHover = el.attr("data-hover-color");
        this.customColor = el.attr("data-color");
        this.customSelected= el.attr("data-color-selected");
        this.init();
    }
    init() {
	    const _self = this;

        this.map.vectorMap(
            {
                map: 'usa_en',
                mode: 'svg',
                backgroundColor : 'transparent',
                borderColor: '#fff',
                borderOpacity: 1,
                borderWidth: 1,
                color: this.customColor == undefined ?  '#f4f3f0' : this.customColor,
                enableZoom: false,
                hoverColor: this.customHover == undefined ?  '#32a4ac' : this.customHover,
                hoverOpacity: null,
                normalizeFunction: 'linear',
                scaleColors: [],
                colors:  this.settings.colors,
                pins:  this.settings.states,
                pinMode: 'content',
                showLabels: true,
                multiSelectRegion: false,
                selectedColor: this.customSelected == undefined ?  '#32a4ac': this.customSelected,
                selectedRegions: null,
                showTooltip: true,
                onRegionSelect: function(event, code,) {
	                _self.map.find('[data-map-labels]').removeClass('active');
	                _self.map.find('[data-map-labels]').filter('[for="jqvmap1_' + code + '"]').addClass('active');
                    _self.clickMap.detail={'region':_self.settings.allStates[code.toUpperCase()], 'code': code}
                    $(window).trigger(_self.clickMap);
                },
                onRegionDeselect: function(event, code) {
	                _self.map.find('[data-map-labels]').filter('[for="jqvmap1_' + code + '"]').removeClass('active');
                    _self.clickMap.detail={'region':'', 'code': code}
                    $(window).trigger(_self.clickMap);
                },
                onRegionOver: function(event, code, region) {
	                _self.map.find('[data-map-labels]').filter('[for="jqvmap1_' + code + '"]').addClass('hover-active');
                },
                onRegionOut: function(event, code, region) {
	                _self.map.find('[data-map-labels]').filter('[for="jqvmap1_' + code + '"]')
		                .removeClass('hover-active');
                },

                onLoad: function(event, _map) {
	                _map.container.addClass('map-init');
                    _self.initedMap = _map
                    _self.renderLabel(_self)
                    _map.positionPins = function() {
                        const map = this;
                        let pins = this.container.find('.jqvmap-pin');

                        jQuery.each(pins, function(index, pinObj){
                            pinObj = jQuery(pinObj);
                            let displacement = {
                                x: 0,
                                y: 0
                            }
                            const offsetPoint = _self.offsetPoint(pinObj.attr('for'))
                            if(offsetPoint) {
                                displacement.x = offsetPoint[0]
                                displacement.y = offsetPoint[1]
                            }

                            const countryId = map.getCountryId(pinObj.attr('for').toLowerCase());
                            const countryObj = jQuery('#' + countryId);

                            const bbox = document.getElementById(countryId).getBBox();
                            const position = countryObj.position();
                            const parents = countryObj.closest('svg').position()
                            const scale = map.scale;

                            const left = position.left - parents.left + (bbox.width / 2) * scale - (pinObj.width() + displacement.x) / 2,
                                top = position.top - parents.top + (bbox.height / 2) * scale - (pinObj.height() + displacement.y)  / 2;

                            pinObj.css('left', left).css('top', top);
                        });
                    }
                   _map.positionPins()
                },
            });
       this.bind()
    }

    bind() {
        this.map.on(
            {
                'mouseenter': (e) => {
                    const label = $(e.currentTarget),
                        id = label.attr('for'),
                        code = label.attr('data-region-code'),
                        pin = this.map.find('#'+id)

                    if (pin.length && this.settings.manualSelectionLabels.indexOf(code) === -1) {
                        pin.trigger('mouseenter')
                    } else {
                        label.addClass('hover-active')
                    }
                },
                'mouseleave': (e) => {
                    const label = $(e.currentTarget),
                        id = label.attr('for'),
                        code = label.attr('data-region-code'),
                        pin = this.map.find('#'+id)

                    if (pin.length && this.settings.manualSelectionLabels.indexOf(code) === -1) {
                        pin.trigger('mouseleave')
                    } else {
                        label.removeClass('hover-active')
                    }
                },
                'click': (e) => {
                    const label = $(e.currentTarget),
                        id = label.attr('for'),
                        code = label.attr('data-region-code'),
                        pin = this.map.find('#'+id);

                    this.map.find( '[data-map-labels]').removeClass('active')
                    label.addClass('active')

                    if (pin.length && this.settings.manualSelectionLabels.indexOf(code) === -1) {
                        pin.trigger('click')
                    } else {
                        this.triggerStateChange(code)
                    }
                },
            }, '[data-map-labels]'
        )
    }

    triggerStateChange(code) {
        if (!code) {
            return;
        }

        this.clickMap.detail = {
            'region': this.settings.allStates[code.toUpperCase()],
            'code': code
        }
        $(window).trigger(this.clickMap);
    }

    offsetPoint(point){
        let offset = {
            'ca':[30, 0],
            'id':[0, -60],
            'ky':[-30, 0],
            'va':[-30, 0],
            'la':[30, 30],
            'fl':[-90, 0],
            'mn':[30, 0],
        }
        if(offset[point]) {
            return offset[point]
        } else {
            return false
        }
    }
    renderLabel(_self) {
        const container =  _self.map.find('[data-state-labels]');

        $.each( _self.settings.statesLabel, (i, e) => {
            let label = $('<label data-map-labels>').attr({
                'for': 'jqvmap1_' + i,
                'data-region-code': i,
                'title': e
            }).text(_self.settings.labelText[i] || i).css('background-color', _self.settings.colors[i] || _self.customColor || '#f4f3f0')

            container.append(label)
        })
    }
}
